import { ApiRequestError } from '../api/types'

import type { CheckoutRestartResponse, CheckoutSession } from '../api/checkout-session-types'

export function checkoutRestartFailureIsTerminal(error: unknown): boolean {
  return (
    error instanceof ApiRequestError &&
    (error.status === 401 ||
      [
        'CHECKOUT_ABANDONMENT_PAYMENT_OBSERVED',
        'CHECKOUT_ABANDONMENT_STATE_CHANGED',
        'CHECKOUT_ABANDONMENT_NOT_SUPPORTED',
        'unauthorized',
      ].includes(error.code ?? ''))
  )
}

export function customerAbandonmentAvailable(session: CheckoutSession | null): boolean {
  return (
    session?.customer_abandonment?.mode === 'confirm_unpaid' &&
    session.customer_abandonment.confirmation_version === 'paypal_unpaid_v1'
  )
}

export function checkoutRestartURL(
  response: CheckoutRestartResponse,
  sourceSessionNo: string,
  checkoutOrigin: string
): string {
  const url = new URL(response.checkout_url)
  const fragment = new URLSearchParams(url.hash.slice(1))
  if (
    !['https:', 'http:'].includes(url.protocol) ||
    url.origin !== new URL(checkoutOrigin).origin ||
    url.username ||
    url.password ||
    url.pathname !== '/checkout' ||
    !response.checkout_session_no ||
    response.checkout_session_no === sourceSessionNo ||
    url.searchParams.get('checkout_session_no') !== response.checkout_session_no ||
    !fragment.get('authorization_code')
  ) {
    throw new Error('Checkout restart destination is invalid')
  }
  return url.toString()
}
